module.exports = __webpack_public_path__ + "img/advantage_4.a82fc9df.png";